export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref10817.049dd381.jpg";